'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _icons = require('icons/icons');

var icons = _interopRequireWildcard(_icons);

var _UISimpleAvatar = require('ui-addon-avatars/UISimpleAvatar');

var _UISimpleAvatar2 = _interopRequireDefault(_UISimpleAvatar);

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

var _images = require('conversations-core/constants/images');

var _LauncherTypes = require('conversations-schema/constants/LauncherTypes');

var _LauncherTypes2 = _interopRequireDefault(_LauncherTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AVATAR = _LauncherTypes2.default.AVATAR;
exports.default = _react2.default.createClass({
  displayName: 'InitialMessageBubble',

  propTypes: {
    initialMessage: _react.PropTypes.string.isRequired,
    avatar: _react.PropTypes.string.isRequired,
    onClick: _react.PropTypes.func.isRequired,
    onClose: _react.PropTypes.func.isRequired,
    coloring: _react.PropTypes.instanceOf(_ColoringRecord2.default),
    launcherType: _react.PropTypes.oneOf(Object.keys(_LauncherTypes2.default))
  },

  renderAvatar: function renderAvatar() {
    var _props = this.props,
        avatar = _props.avatar,
        onClick = _props.onClick,
        coloring = _props.coloring,
        launcherType = _props.launcherType;


    if (launcherType === AVATAR) {
      return null;
    }

    var accentColor = void 0;

    if (coloring) {
      accentColor = coloring.accentColor;
    }

    return _react2.default.createElement(
      'div',
      {
        className: 'initial-message-avatar',
        style: { borderColor: accentColor },
        onClick: onClick
      },
      _react2.default.createElement(_UISimpleAvatar2.default, { src: avatar, size: 'sm' })
    );
  },
  renderCloseButton: function renderCloseButton() {
    return _react2.default.createElement(
      _UIButton2.default,
      {
        className: 'initial-message-close-button',
        use: 'unstyled',
        size: 'extra-small',
        responsive: false,
        onClick: this.props.onClose
      },
      _react2.default.createElement(_UIIcon2.default, { name: icons.REMOVE })
    );
  },
  render: function render() {
    var _props2 = this.props,
        initialMessage = _props2.initialMessage,
        onClick = _props2.onClick;


    return _react2.default.createElement(
      'div',
      { className: 'initial-message-bubble' },
      this.renderCloseButton(),
      this.renderAvatar(),
      _react2.default.createElement(
        'p',
        {
          className: 'initial-message-text m-top-1 m-bottom-0',
          onClick: onClick
        },
        initialMessage
      ),
      _react2.default.createElement(_UIImage2.default, {
        className: 'initial-message-bubble-tail',
        src: _images.initialMessageBubbleTail
      })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/components/widget/InitialMessageBubble.js
// module id = 278
// module chunks = 0 1